import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import "../styles/MiniDash.css";
import flat from "../images/fiat.png";

const SkeletonLoader = () => (
  <div className="dashboardContainer">
    <div className="profileSection">
      <div className="skeletonImage" />
      <div className="profileDetails">
        <div className="skeletonText skeletonName" />
        <div className="skeletonText skeletonEmail" />
      </div>
    </div>
  </div>
);

function MiniDash({ closeMenu }) {
  const [user, setUser] = useState(null);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();

    const fetchTransactions = async (currentUser) => {
      try {
        const userDocRef = doc(db, "greenwtb", currentUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUser({
            name: userData.fullName || "Guest User",
            accountNumber: userData.accountNumber || currentUser.email,
            profilePhotoUrl: userData.profilePictureUrl || currentUser.photoURL || flat,
          });

          const transactions = userData.transactions || [];
          const calculatedBalance = transactions.reduce((total, transaction) => {
            return transaction.type === "credit"
              ? total + transaction.amount
              : total - transaction.amount;
          }, 0);

          setBalance(calculatedBalance);
        } else {
          console.error("User document not found.");
          setUser(null);
          setBalance(0);
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
      setLoading(false);
    };

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        fetchTransactions(currentUser);
      } else {
        setUser(null);
        setBalance(0);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <SkeletonLoader />;
  }

  if (!user) {
    return <p>No user data available.</p>;
  }


  return (
    <div className="dashboardContainer">
      <div className="profileSection">
        <img
          src={user.profilePhotoUrl}
          alt="Profile"
          className="profileImages"
        />
        <div className="profileDetails">
          <div className="profileName">{user.name}</div>
          <div className="balanceSection">
            <strong>Balance: </strong> <span className="bal"> ${balance.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MiniDash;
